import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

export default function Logout(props) {
  const history = useHistory();

  useEffect(() => {
    localStorage.removeItem("email");
    localStorage.removeItem("tal_id");
    localStorage.removeItem("linkedInId");
    localStorage.removeItem("githubId");

    setTimeout(() => {
      history.push(`/`);
    }, 500);
  }, []);

  return (
    <React.Fragment>
      <div>
        Logout ....
      </div>
    </React.Fragment>
  );
}
